export default __webpack_public_path__ + "static/NACFB-logo-48a6bb63cb5cfc1bbfa552aa2691cfef.png";